import React from "react";

import WebinarCard from "./WebinarCard";
import RequestWebinarCard from "./RequestWebinarCard";

import { Container, Wrapper, ListDiv } from "./style";

function WebinarListing(props) {
  const { data = {}, upcomingWebinarRef, onShowModalClick } = props || {};

  return (
    <Wrapper ref={upcomingWebinarRef}>
      <Container>
        <ListDiv>
          {data?.webinar_list?.upcoming_webinars?.map((item, index) => (
            <WebinarCard key={`${item.title}-${index}`} item={item} />
          ))}
          {data?.request_webinar_card?.cta && (
            <RequestWebinarCard
              data={data}
              onShowModalClick={onShowModalClick}
            />
          )}
        </ListDiv>
      </Container>
    </Wrapper>
  );
}

export default WebinarListing;
